import React from 'react';
import { Alert } from 'react-bootstrap';

const AlertMessage = ({ show, variant, message, onClose }) => {
  if (!show) return null;

  return (
    <Alert variant={variant} dismissible onClose={onClose}>
      {message}
    </Alert>
  );
};

export default AlertMessage;